import React from 'react';
import { Section, FadeIn, Button } from './ui';
import { CheckIcon } from 'lucide-react';
export function Pricing() {
  const plans = [{
    name: 'Free',
    price: '$0',
    desc: 'Best for designing an offsite.',
    features: ['AI Offsite Designer', 'Custom agenda outline', 'Activity recommendations', 'Reflection prompts', 'Intake question suggestions', 'Exportable plan summary'],
    cta: 'Design Free Offsite',
    href: '/designer',
    highlight: false
  }, {
    name: 'Starter',
    price: '$499',
    period: '/ event',
    desc: 'Best for small offsites and training days.',
    features: ['Branded intake form', 'Basic event hub', 'Agenda page', 'Participant introductions', 'Up to 50 attendees', 'Basic survey', 'Simple post-event summary'],
    cta: 'Start an Event',
    highlight: false
  }, {
    name: 'Professional',
    price: '$1,500',
    period: '/ event',
    desc: 'Best for planners, DMCs, and corporate retreats.',
    features: ['Up to 150 attendees', 'Custom event branding', 'AI-generated agenda and prompts', 'Wellness and activity preferences', 'Small group matching', 'Pre/post surveys', 'Engagement dashboard', 'Client-ready report'],
    cta: 'Launch a Guided Offsite',
    highlight: true
  }, {
    name: 'Premium',
    price: '$3,500',
    period: '/ event',
    desc: 'Best for leadership retreats and destination events.',
    features: ['Up to 300 attendees', 'Custom learning modules', 'Facilitator guide', 'Executive pathway', 'Custom wellness track', 'Advanced reporting', '30-day accountability flow', 'White-glove setup'],
    cta: 'Build Premium Retreat',
    highlight: false
  }, {
    name: 'Partner',
    price: 'Custom',
    period: 'annual license',
    desc: 'Best for hotels, resorts, DMCs, and event companies running multiple events.',
    features: ['White-label branding', 'Multiple events', 'Reusable templates', 'Team accounts', 'Partner dashboard', 'Proposal support', 'Training', 'Priority support'],
    cta: 'Become a Partner',
    highlight: false
  }];
  return <Section id="pricing" className="bg-white" data-id="element-6237">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-6238">
        <FadeIn data-id="element-6239">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-6240">
            Pricing for single events, premium retreats, and hospitality
            partners.
          </h2>
        </FadeIn>
      </div>

      <div className="flex flex-wrap justify-center gap-6 max-w-7xl mx-auto" data-id="element-6241">
        {plans.map((plan, i) => <FadeIn key={i} delay={i * 0.1} className={`flex-1 min-w-[280px] max-w-[340px] flex flex-col ${plan.highlight ? 'md:-mt-4 md:mb-4' : ''}`} data-id="element-6242">
            <div className={`relative h-full flex flex-col bg-white rounded-2xl p-8 transition-all duration-300 hover:shadow-xl ${plan.highlight ? 'border-2 border-brand-coral shadow-lg scale-105 z-10' : 'border border-slate-200 shadow-sm'}`} data-id="element-6243">
              {plan.highlight && <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-brand-coral text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-6244">
                  Recommended
                </div>}

              <div className="mb-6" data-id="element-6245">
                <h3 className="text-xl font-bold text-brand-navy mb-2" data-id="element-6246">
                  {plan.name}
                </h3>
                <div className="flex items-baseline gap-1 mb-3" data-id="element-6247">
                  <span className="text-3xl font-black text-slate-800" data-id="element-6248">
                    {plan.price}
                  </span>
                  {plan.period && <span className="text-sm text-slate-500 font-medium" data-id="element-6249">
                      {plan.period}
                    </span>}
                </div>
                <p className="text-sm text-slate-600 h-10" data-id="element-6250">{plan.desc}</p>
              </div>

              <div className="flex-1" data-id="element-6251">
                <ul className="space-y-3 mb-8" data-id="element-6252">
                  {plan.features.map((feat, j) => <li key={j} className="flex items-start gap-3 text-sm text-slate-700" data-id="element-6253">
                      <CheckIcon className={`w-4 h-4 shrink-0 mt-0.5 ${plan.highlight ? 'text-brand-coral' : 'text-brand-teal'}`} data-id="element-6254" />
                      <span data-id="element-6255">{feat}</span>
                    </li>)}
                </ul>
              </div>

              <Button variant={plan.highlight ? 'accent' : plan.name === 'Free' ? 'outline' : 'primary'} className="w-full" href={plan.href} data-id="element-6256">
                {plan.cta}
              </Button>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
}